<section class="org-target-settings" aria-labelledby="org-target-heading">
  <h2 id="org-target-heading">組織目標（ボード全体）</h2>
  <p>
    ボード全体の目標です。オペレーター一覧の「{{ dashboard.name }}
    ALL」行の目標・達成状況に使われます。設定した月以降は、次に設定する月まで同じ目標が引き継がれます。
  </p>
  @if (!isLoading && loadErrorMessage === '') {
    <p class="form-status" role="status">{{ formStatus }}</p>
  }
  <fieldset [disabled]="isBusy || isLoading || loadErrorMessage !== ''">
    <legend>組織目標の入力</legend>
    <label class="period-field">
      対象年月
      <input
        type="month"
        [(ngModel)]="period"
        (ngModelChange)="onPeriodChanged()"
      />
    </label>
    <div class="target-fields">
      @for (field of fields; track field) {
        <label>
          {{ field.label }}（%）
          <input
            type="number"
            min="0"
            step="0.1"
            [value]="field.targetRate ?? ''"
            (input)="onTargetInput(field, $event)"
          />
        </label>
      }
    </div>
    <p class="helper-note">
      空欄・0
      は未設定です。すべて未設定で保存すると、この月以降の組織目標を解除します。
    </p>
    @if (validationMessage) {
      <p class="error-message" role="alert">{{ validationMessage }}</p>
    }
    <button
      type="button"
      class="btn btn-primary save-button"
      [disabled]="validationMessage !== '' || isBusy"
      (click)="save()"
    >
      {{ isSaving ? '保存中...' : '保存' }}
    </button>
  </fieldset>
  @if (saveErrorMessage) {
    <p class="error-message" role="alert">{{ saveErrorMessage }}</p>
  }
  <h3>設定済み一覧</h3>
  <p class="helper-note">
    この月以降を未設定にしたいときは、その月を選んで全項目を空欄にして保存してください。直前の月の設定に戻したいときは「削除」を使ってください。
  </p>
  @if (isLoading) {
    <p role="status">組織目標を読み込んでいます。</p>
  } @else if (loadErrorMessage) {
    <div role="alert" class="error-message">
      <p>{{ loadErrorMessage }}</p>
      <button type="button" class="btn btn-secondary" (click)="load()">
        再試行
      </button>
    </div>
  } @else if (rows.length === 0) {
    <p>組織目標はまだ設定されていません。</p>
  } @else {
    <div class="table-wrap">
      <table aria-label="組織目標の設定済み一覧">
        <thead>
          <tr>
            <th scope="col">対象年月</th>
            @for (item of dashboard.items; track item.id) {
              <th scope="col">{{ item.kpiName }}（%）</th>
            }
            <th scope="col">最終更新日時</th>
            <th scope="col">操作</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.source.period) {
            <tr>
              <th scope="row">{{ row.periodLabel }}</th>
              @if (row.isCleared && dashboard.items.length > 0) {
                <td [attr.colspan]="dashboard.items.length">
                  解除（この月以降は未設定）
                </td>
              } @else {
                @for (value of row.values; track $index) {
                  <td>{{ value }}</td>
                }
              }
              <td>{{ row.source.updatedAt | date: 'yyyy/MM/dd HH:mm' }}</td>
              <td class="actions">
                <button
                  type="button"
                  class="btn btn-secondary edit-button"
                  [disabled]="isBusy"
                  [attr.aria-label]="row.periodLabel + 'の組織目標を編集'"
                  (click)="edit(row)"
                >
                  編集
                </button>
                <button
                  type="button"
                  class="btn btn-secondary delete-button"
                  [disabled]="isBusy"
                  [attr.aria-label]="row.periodLabel + 'の組織目標を削除'"
                  (click)="delete(row)"
                >
                  {{
                    isDeletingPeriod === row.source.period
                      ? '削除中...'
                      : '削除'
                  }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</section>
